import { modalControl } from '../../modal';
import { TAX_FORM } from './form-tax-types';
import { displaySelectedValue } from '../../dropdown';

import { ITaxList } from '../../../models/taxes.interface';

/**
 * Function to display the tax modal
 * 
 * @param {HTMLElement} modalElement the modal element
 * @param {string} modalMSG the modal message
 * @param {ITaxList} data optional tax data
 * 
 * @returns void
 */
const TaxModalDisplay = ( modalElement: HTMLElement, modalMSG: string, data?: ITaxList ) => {
  if ( !modalElement ) return;

  modalControl(modalElement, modalMSG);

  if (data) {
    const { taxId, partnerId, taxName, taxRateCentsOrPercent, taxType } = data;

    TAX_FORM.txName.value = taxName;
    TAX_FORM.txName.setAttribute('data-id', `${taxId}`);
    TAX_FORM.txAmount.value = `${taxRateCentsOrPercent}`;
    displaySelectedValue('.aafp_list-tax-type', 'tax-type', taxType);
    displaySelectedValue('.aafp_list-partner', 'partner', `${partnerId}`);
  } 
}

export default TaxModalDisplay;